import request from '../utils/request'

export function getDeptTree() {
  return request({
    url: '/manager/org/dept/tree',
    method: 'get'
  })
}

export function createDept(data) {
  return request({
    url: '/manager/org/dept',
    method: 'post',
    data
  })
}

export function updateDept(data) {
  return request({
    url: '/manager/org/dept',
    method: 'put',
    data
  })
}

export function deleteDept(deptId) {
  return request({
    url: `/manager/org/dept/${deptId}`,
    method: 'delete'
  })
}

export function bindUserPrimaryDept(data) {
  return request({
    url: '/manager/org/dept/bind-primary',
    method: 'put',
    data
  })
}

